import { ReactElement, useState } from 'react'
import { ActionCreatorWithPayload } from '@reduxjs/toolkit'
import Avatar from '@mui/material/Avatar'
import Chip from '@mui/material/Chip'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { CancelIcon } from 'src/v3/core/icons'
import { useAppDispatch } from 'src/store/hooks'
import { LinkedService } from '../core/types'

interface Props {
  linkedServices: LinkedService[]
  linkedServiceID: string
  activeLinkedServiceChanged: ActionCreatorWithPayload<string>
}

let SelectLinkedService = ({
  linkedServices,
  linkedServiceID,
  activeLinkedServiceChanged,
}: Props): ReactElement => {
  let dispatch = useAppDispatch()

  let [linkedServiceChip, setLinkedServiceChip] = useState<null | HTMLElement>(
    null,
  )
  let linkedServiceMenuOpen = Boolean(linkedServiceChip)

  let handleSelectActiveLinkedService = (id: string) => () => {
    dispatch(activeLinkedServiceChanged(id))
  }

  let handleLinkedServiceSelectorOpen = (
    event: React.MouseEvent<HTMLElement>,
  ) => {
    setLinkedServiceChip(event.currentTarget)
  }

  let handleLinkedServiceSelectorClose = () => {
    setLinkedServiceChip(null)
  }

  let linkedService = linkedServices.find((ls) => ls.id === linkedServiceID)

  return (
    <span>
      <Chip
        color="primary"
        variant={linkedService?.name ? 'filled' : 'outlined'}
        label={linkedService?.name ?? 'Select a Linked Service'}
        avatar={
          <Avatar
            src={`${import.meta.env.VITE_CLOUDFRONT_URL}/public/${linkedService?.imageName}`}
          >
            LS
          </Avatar>
        }
        onClick={handleLinkedServiceSelectorOpen}
      />
      <Menu
        anchorEl={linkedServiceChip}
        id="account-menu"
        open={linkedServiceMenuOpen}
        onClose={handleLinkedServiceSelectorOpen}
        onClick={handleLinkedServiceSelectorClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: 'scroll',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&:before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem onClick={handleSelectActiveLinkedService('unselected')}>
          <Avatar>
            <CancelIcon />
          </Avatar>
          Remove Selection
        </MenuItem>
        {linkedServices.map((ls) => (
          <MenuItem
            key={ls.id}
            onClick={handleSelectActiveLinkedService(ls.id ?? '')}
          >
            <Avatar
              src={`${import.meta.env.VITE_CLOUDFRONT_URL}/public/${ls?.imageName}`}
            >
              LS
            </Avatar>{' '}
            {ls.name}
          </MenuItem>
        ))}
      </Menu>
    </span>
  )
}

export default SelectLinkedService
